import { campoObrigatorio } from '../../helpers/Constantes/Mensagens'
export type DadosClonarViabilidade = {
  idViabilidade: string
  nomeViabilidadeClonar: string
  valido: boolean
}

export const clonarViabilidadeDefault = {
  idViabilidade: '',
  nomeViabilidadeClonar: '',
  valido: false
} as DadosClonarViabilidade

export class ValidacaoDadosClonarViabilidade {
  nomeViabilidadeClonar: string

  constructor(nomeViabilidadeClonar = '') {
    this.nomeViabilidadeClonar = nomeViabilidadeClonar
  }

  validarNomeViabilidadeClonar(nomeViabilidadeClonar: string): string {
    let error = ''

    if (!nomeViabilidadeClonar || nomeViabilidadeClonar === '') {
      error = campoObrigatorio
    }

    return error
  }

  validarCard(nomeViabilidadeClonar: string): boolean {
    return nomeViabilidadeClonar != '' && this.nomeViabilidadeClonar === ''
  }
}
